import * as React from "react";
import {
  AppItem,
  Avatar,
  Button,
  NavDivider,
  NavDrawer,
  NavDrawerBody,
  Tooltip,
  useRestoreFocusTarget,
} from "@fluentui/react-components";
import { bundleIcon, DismissFilled, DismissRegular, PersonFilled, PersonRegular } from "@fluentui/react-icons";

import SignOutButton from "./SignOutButton";
import SignInButton from "./SignInButton";
import ThemeSwitcher from "./ThemeSwitcher";

import { DrawerContext } from "../store/drawer-navigator-context-api";
import { UserContext } from "../store/user-contex-api";
import { useIconButtonStyles } from "../styles/styles";

const UserIcon = bundleIcon(PersonFilled, PersonRegular);
const CloseBtnIcon = bundleIcon(DismissFilled, DismissRegular);

const CloseDrawer = ({ setIsDrawerOpen, ...props }) => {
  const iconStyles = useIconButtonStyles();
  return (
    <Tooltip content="Close Nav drawer" relationship="label" withArrow>
      <Button
        className={iconStyles.dark}
        icon={<CloseBtnIcon />}
        onClick={() => setIsDrawerOpen(false)}
        appearance="subtle"
        {...props}
      />
    </Tooltip>
  );
};

export default function Navigator() {
  const { isDrawerOpen, setIsDrawerOpen } = React.useContext(DrawerContext);
  const { isAuthenticated, name } = React.useContext(UserContext);
  const restoreFocusTargetAttributes = useRestoreFocusTarget();
  const iconStyles = useIconButtonStyles();

  return (
    <NavDrawer open={isDrawerOpen} type="overlay" className="min-w-[200px]">
      <NavDrawerBody>
        <div className="flex justify-between">
          <AppItem
            className={iconStyles.dark}
            icon={<Avatar color="colorful" icon={<UserIcon />} name={name} size={32} />}
          >
            {name}
          </AppItem>
          <div className="flex">
            <ThemeSwitcher />
            <CloseDrawer setIsDrawerOpen={setIsDrawerOpen} {...restoreFocusTargetAttributes} />
          </div>
        </div>
        <NavDivider />
        {isAuthenticated ? <SignOutButton appearance="secondary" /> : <SignInButton appearance="primary" />}
      </NavDrawerBody>
    </NavDrawer>
  );
}
